import {Action, ActionReducerMap, createFeatureSelector, createSelector} from '@ngrx/store';
import {PAGE_STATE_RESET, PageStateResetAction, SETZE_CHECKLISTE, SETZE_CURRENT_SLIDE_INDEX, SETZE_FUNKTIONSBEREICH, SetzeChecklisteAction, SetzeCurrentSlideIndexAction, SetzeFunktionsbereichAction} from './funktionsbereich-checklisten-aufgaben.actions.ui';
import {GET_FUNKTIONSBEREICH_CHECKLISTEN_AUFGABEN, GET_FUNKTIONSBEREICH_CHECKLISTEN_AUFGABEN_ERFOLGREICH, GET_FUNKTIONSBEREICH_CHECKLISTEN_AUFGABEN_FEHLER, GetFunktionsbereichChecklistenAufgabenAction, GetFunktionsbereichChecklistenAufgabenErfolgreichAction, GetFunktionsbereichChecklistenAufgabenFehlerAction} from '../../../../client-ngrx/veranstaltungen';
import {Checkliste, Funktionsbereich, PhasenChecklistenAufgaben} from '../../../../clients/veranstaltungen';
import {SETZE_FUNKTIONSBEREICH_CHECKLISTE_ACTION, SetzeFunktionsbereichChecklisteAction} from '../../app-state/actions/app-state.actions.ui';
import {APP_RESET_ACTION} from '@orga-app/appstart/actions';
import {AKTUELLE_VERANSTALTUNG_SETZEN} from '../../app-state/actions/veranstaltung.actions';


export interface ModuleState {
    page: PageState;
}

export const reducers: ActionReducerMap<ModuleState> = {
    page: pageReducer
};

export interface PageState {
    phasenChecklistenAufgaben: Array<PhasenChecklistenAufgaben>;
    uiZeigeFbChecklistenAufgabenLaden: boolean;
    uiZeigeFbChecklistenAufgabenLadenFehler: boolean;
    aktuelleCheckliste: Checkliste;
    aktuellerFunktionsbereich: Funktionsbereich;
    initialSlide: number;
}

export const initialPageState: PageState = {
    phasenChecklistenAufgaben: null,
    uiZeigeFbChecklistenAufgabenLaden: false,
    uiZeigeFbChecklistenAufgabenLadenFehler: false,
    aktuelleCheckliste: null,
    aktuellerFunktionsbereich: null,
    initialSlide: null
};

export function pageReducer(state = initialPageState, action: Action): PageState {
    switch (action.type) {
        // APP RESET
        case APP_RESET_ACTION: {
            return Object.assign({}, state, <PageState> initialPageState);
        }

        // Page State Reset
        case PAGE_STATE_RESET: {
            const a = <PageStateResetAction> action;

            return Object.assign({}, state, <PageState> initialPageState);
        }

        case AKTUELLE_VERANSTALTUNG_SETZEN: {
            return Object.assign({}, state, <PageState> initialPageState);
        }

        // Funktionsbereich Checklisten Aufgaben
        case GET_FUNKTIONSBEREICH_CHECKLISTEN_AUFGABEN: {
            const a = <GetFunktionsbereichChecklistenAufgabenAction> action;

            return Object.assign({}, state, <PageState> {
                uiZeigeFbChecklistenAufgabenLaden: true
            });
        }

        case GET_FUNKTIONSBEREICH_CHECKLISTEN_AUFGABEN_ERFOLGREICH: {
            const action1 = <GetFunktionsbereichChecklistenAufgabenErfolgreichAction> action;
            let phasenChecklistenAufgabenWrapped = [...action1.payload];

            // SORTIEREN DER CHECKLISTEN - Hat über den Selector nicht geklappt, da der Slider sonst bei jedem zweiten hin und her immer auf 0 initalisiert hat
            if (!(phasenChecklistenAufgabenWrapped === null || phasenChecklistenAufgabenWrapped === undefined)) {

                phasenChecklistenAufgabenWrapped = phasenChecklistenAufgabenWrapped
                    .sort((a, b) => {
                        if (a && a.checkliste.titel && b && b.checkliste.titel && a.checkliste.titel.toLowerCase() < b.checkliste.titel.toLowerCase()) {
                            return -1;
                        }
                        if (a && a.checkliste.titel && b && b.checkliste.titel && a.checkliste.titel.toLowerCase() > b.checkliste.titel.toLowerCase()) {
                            return 1;
                        }
                        return 0;
                    }).sort((a, b) => {
                        if (a.checkliste.reihenfolge < b.checkliste.reihenfolge) {
                            return -1;
                        }
                        if (a.checkliste.reihenfolge > b.checkliste.reihenfolge) {
                            return 1;
                        }
                        return 0;
                    });

                phasenChecklistenAufgabenWrapped = phasenChecklistenAufgabenWrapped.map((item: PhasenChecklistenAufgaben) => {
                    const phasen = item.phasen.map((phase) => {
                        let aufgaben = [...phase.aufgaben];
                        aufgaben = aufgaben.sort((a, b) => {
                            if (a && a.titel && b && b.titel && a.titel.toLowerCase() < b.titel.toLowerCase()) {
                                return -1;
                            }
                            if (a && a.titel && b && b.titel && a.titel.toLowerCase() > b.titel.toLowerCase()) {
                                return 1;
                            }
                            return 0;
                        }).sort((a, b) => {
                            if (a.reihenfolge < b.reihenfolge) {
                                return -1;
                            }
                            if (a.reihenfolge > b.reihenfolge) {
                                return 1;
                            }
                            return 0;
                        });
                        return Object.assign({}, phase, {aufgaben});
                    });
                    return Object.assign({}, item, {phasen});
                });
            }

            let index = state.initialSlide;

            if (phasenChecklistenAufgabenWrapped != null) {
                index = phasenChecklistenAufgabenWrapped.findIndex(y => state.aktuelleCheckliste !== null && y.checkliste.checkliste_id === state.aktuelleCheckliste.checkliste_id);
                if (index === -1) {
                    index = 0;
                }
            }
            return Object.assign({}, state, <PageState> {
                phasenChecklistenAufgaben: phasenChecklistenAufgabenWrapped,
                uiZeigeFbChecklistenAufgabenLaden: false,
                initialSlide: index
            });
        }

        case GET_FUNKTIONSBEREICH_CHECKLISTEN_AUFGABEN_FEHLER: {
            const a = <GetFunktionsbereichChecklistenAufgabenFehlerAction> action;

            return Object.assign({}, state, <PageState> {
                phasenChecklistenAufgaben: [],
                uiZeigeFbChecklistenAufgabenLaden: false,
                uiZeigeFbChecklistenAufgabenLadenFehler: true
            });
        }

        case SETZE_CHECKLISTE: {
            const a = <SetzeChecklisteAction> action;

            return Object.assign({}, state, <PageState> {
                aktuelleCheckliste: a.checkliste
            });
        }

        case SETZE_FUNKTIONSBEREICH: {
            const a = <SetzeFunktionsbereichAction> action;

            return Object.assign({}, state, <PageState> {
                aktuellerFunktionsbereich: a.funktionsbereich
            });
        }

        case SETZE_FUNKTIONSBEREICH_CHECKLISTE_ACTION: {
            const a = <SetzeFunktionsbereichChecklisteAction>action;

            return Object.assign({}, state, <PageState> {
                aktuellerFunktionsbereich: a.funktionsbereich,
                aktuelleCheckliste: a.checkliste
            });
        }

        case SETZE_CURRENT_SLIDE_INDEX: {
            const a = <SetzeCurrentSlideIndexAction> action;

            return Object.assign({}, state, <PageState> {
                initialSlide: a.index
            });
        }

        default: {
            return state;
        }
    }
}


/**
 * The createFeatureSelector function selects a piece of state from the root of the state object.
 * This is used for selecting feature states that are loaded eagerly or lazily.
 */
export const getModuleState = createFeatureSelector<ModuleState>('FunktionsbereichChecklistenAufgabenPage');

export const getPageState = createSelector(getModuleState, (state: ModuleState) => state.page);

// DATA
export const getPhasenChecklistenAufgaben = createSelector(getPageState, (state: PageState) => state.phasenChecklistenAufgaben);
export const getUiZeigeFbChecklistenAufgabenLaden = createSelector(getPageState, (state: PageState) => state.uiZeigeFbChecklistenAufgabenLaden);
export const getUiZeigeFbChecklistenAufgabenLadenFehler = createSelector(getPageState, (state: PageState) => state.uiZeigeFbChecklistenAufgabenLadenFehler);
export const getAktuellerFunktionsbereich = createSelector(getPageState, (state: PageState) => state.aktuellerFunktionsbereich);
export const getAktuelleCheckliste = createSelector(getPageState, (state: PageState) => state.aktuelleCheckliste);
export const getInitialSlide = createSelector(getPageState, (state: PageState) => state.initialSlide);
export const getSlideOps = createSelector(getInitialSlide, (initialSlide: number) => {
    return {
        initialSlide,
        slidesPerView: 1
    };
});
